import { useContext } from 'react'

import CurrentUserContext from 'contexts/current-user-context'

const useCurrentUser = (): { isAdmin: boolean; data: any } =>
  useContext(CurrentUserContext)

export default useCurrentUser
